import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import NonMemberSignupForm from '../Organization/Content/NonMemberSignUp/NonMemberSignupForm/NonMemberSignupForm';
import {
  MainContainer,
  PreviewContainer,
} from './NonMemberSignUpLandingPage.styled';
import { getNonMemberFormPageData } from '../../redux/services/nonmemberSignUp';
import { getQueryStringValue } from '../../redux/helpers';
import { FullSpinner } from '../../Component/FullSpinner';

const NonMemberSignUpLandingPage = () => {
  const [organizationName, setOrganizationName] = useState('');
  const [headerText, setHeaderText] = useState('');
  const [logoUrl, setLogoUrl] = useState('');
  const [loading, setLoading] = useState(true); // Start with loading true
  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    // Check if the page is embedded (in iframe)
    const checkIfEmbedded = () => {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };

    setIsEmbedded(checkIfEmbedded());

    const fetchData = async () => {
      setLoading(true);
      const id = getQueryStringValue('orgId');
      const acronym = getQueryStringValue('acronym');

      try {
        const { error, logoUrl, organizationName, formHeader } =
          await getNonMemberFormPageData(id, acronym);

        if (!error) {
          // Ensure organizationName is a string
          const orgName =
            typeof organizationName === 'string'
              ? organizationName
              : organizationName?.name ||
                organizationName?.organizationName ||
                '';
          setOrganizationName(orgName);
          setHeaderText(formHeader);
          setLogoUrl(logoUrl);
        } else {
          console.error('Error fetching non-member form header');
        }
      } catch (err) {
        console.error('Error fetching non-member form header:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {loading ? (
        <FullSpinner />
      ) : (
        <MainContainer embedded={isEmbedded}>
          <PreviewContainer embedded={isEmbedded}>
            <NonMemberSignupForm
              preview={false}
              headerText={headerText}
              logoUrl={logoUrl}
              organizationName={organizationName}
            />
          </PreviewContainer>
        </MainContainer>
      )}
    </>
  );
};

export default NonMemberSignUpLandingPage;
